// extracted by mini-css-extract-plugin
export default {"Icon":"Accordion_Icon__0TYJr","ButtonLabelHidden":"Accordion_ButtonLabelHidden__rlj+e","Spinner":"Accordion_Spinner__ncU75","StepDetails":"Accordion_StepDetails__KWWm2"};